import { useState, useCallback, useEffect } from "react";

let logoutTimer;

let TGRIDAMIND_logoutTimer;

export const useAuth = () => {
  /////////// new user

  // const [token, setToken] = useState(false);

  const [loginVar, setloginVar] = useState(null);
  const [tokenExpirationDate, setTokenExpirationDate] = useState(null);

  const login = useCallback((userData, expDate) => {
    // console.log("this is user data");
    //console.log(userData);
    setloginVar(userData);
    setTokenExpirationDate(
      expDate || new Date(new Date().getTime() + 17 * 24 * 60 * 60 * 1000)
    );
  }, []);

  const logout = useCallback(async () => {
    try {
      // Tell the server to kill the HTTP-only cookie
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/userLogout`,
        {
          method: "POST", // Change to GET if you set your Express route as router.get
          credentials: "include", // Crucial: sends the cookie to be destroyed
        }
      );
    } catch (err) {
      console.error("Logout failed on server:", err);
    }

    // Clear local React state
    setTokenExpirationDate(null);
    setloginVar(null);
  }, []);
  useEffect(() => {
    if (tokenExpirationDate) {
      //console.log("logout sent vvvv");
      const remainingTime =
        tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [logout, tokenExpirationDate]);

  useEffect(() => {
    const checkAuthStatus = async () => {
      //console.log("check auth attempted");
      //console.log(process.env.REACT_APP_BACKEND_URL);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/userTemplegridGo`,
          {
            // Create this endpoint on server
            credentials: "include", // Crucial: sends the cookie
            mode: "cors",
          }
        );

        //console.log("this is response check auth");
        // console.log(response);

        if (response.ok) {
          const data = await response.json();

          const expirationDate = data.exp
            ? new Date(data.exp * 1000)
            : new Date(new Date().getTime() + 17 * 24 * 60 * 60 * 1000);

          // console.log("here is response okay ");
          // console.log(data.loginVar.loginVar);
          //console.log(data.loginVar);
          //console.log(data);
          login(data.loginVar.loginVar, expirationDate); // make sure login accepts 2 args
        }
        // If not ok (401), do nothing → stay logged out
      } catch (err) {
        //console.error("Auth check failed", err);
      }
    };

    checkAuthStatus();
  }, [login]);
  ////////// old user

  //////////// tgrid admin

  //const [TGRIDAMIND_token, setTGRIDAMIND_Token] = useState(false);
  ///const [TGRIDAMIND_tokenExpirationDate, setTGRIDAMIND_TokenExpirationDate] =
  //useState();
  // const [TGRIDAMIND_loginVar, setTGRIDAMIND_loginVar] = useState(false);

  // const TGRIDAMIND_login = useCallback(
  //   ////////
  // //   (TGRIDAMIND_loginVar, TGRIDAMIND_token, TGRIDAMIND_expirationDate) => {
  // //     setTGRIDAMIND_Token(TGRIDAMIND_token);
  // //     setTGRIDAMIND_loginVar(TGRIDAMIND_loginVar);

  // //     const TGRIDAMIND_tokenExpirationDate =
  // //       TGRIDAMIND_expirationDate ||
  // //       new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 17);
  // //     setTGRIDAMIND_TokenExpirationDate(TGRIDAMIND_tokenExpirationDate);
  // //   },
  // //   []
  // // );

  // )

  const [TGRIDAMIND_loginVar, setTGRIDAMIND_loginVar] = useState(null);
  const [TGRIDAMIND_tokenExpirationDate, setTGRIDAMIND_TokenExpirationDate] =
    useState(null);

  const TGRIDAMIND_login = useCallback((userData) => {
    setTGRIDAMIND_loginVar(userData);

    const expDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 17);
    setTGRIDAMIND_TokenExpirationDate(expDate);
  }, []);

  const TGRIDAMIND_logout = useCallback(() => {
    // setTGRIDAMIND_Token(null);
    setTGRIDAMIND_TokenExpirationDate(null);
    setTGRIDAMIND_loginVar(null);
  }, []);

  useEffect(() => {
    if (TGRIDAMIND_tokenExpirationDate) {
      const TGRIDAMIND_remainingTime =
        TGRIDAMIND_tokenExpirationDate.getTime() - new Date().getTime();
      TGRIDAMIND_logoutTimer = setTimeout(
        TGRIDAMIND_logout,
        TGRIDAMIND_remainingTime
      );
    } else {
      clearTimeout(TGRIDAMIND_logoutTimer);
    }
  }, [TGRIDAMIND_logout, TGRIDAMIND_tokenExpirationDate]);

  ///// un comment when ready vvvv

  // useEffect(() => {
  //   const TGRIDAMIND_checkAuthStatus = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_BACKEND_URL}/amindUse/zeusapolis/mindLawUser`,
  //         {
  //           // Create this endpoint on server
  //           credentials: "include", // Crucial: sends the cookie
  //         }
  //       );

  //       if (response.ok) {
  //         const data = await response.json();
  //         // data should contain: { user: { uID, username, ... }, exp: timestamp or ISO string }

  //         const expirationDate = data.exp
  //           ? new Date(data.exp * 1000) // if exp is Unix timestamp (from JWT)
  //           : new Date(data.expiration); // or if you send ISO string
  //         //console.log(data);
  //         TGRIDAMIND_login(TGRIDAMIND_loginVar, expirationDate);
  //       }
  //       // If not ok (401), do nothing → stay logged out
  //     } catch (err) {
  //       // console.error("Auth check failed", err);
  //     }
  //   };

  //   TGRIDAMIND_checkAuthStatus();
  // }, [TGRIDAMIND_login, TGRIDAMIND_loginVar]);

  //const isLoggedIn = !!loginVar;

  const TGRIDAMIND_isLoggedIn = !!TGRIDAMIND_loginVar;
  return {
    login,
    logout,
    loginVar,
    //isLoggedIn,
    TGRIDAMIND_isLoggedIn,
    TGRIDAMIND_login,
    TGRIDAMIND_logout,
    TGRIDAMIND_loginVar,
  };
};
